import React, { useContext } from "react";
import { Layout, Menu } from "antd";
import "./userprofile.css";
import { BasicSettingsView } from "./BasicSettingsView";
import { SecuritySettingsView } from "./SecuritySettingsView";
import { NotificationSettingsView } from "./NotificationSettingsView";
import { ProgressIndicator } from "@fluentui/react";
import { observer } from "mobx-react-lite";
import ProfileStore from "../store/profilestore";
import { UserPermission } from "./UserPermission";
const { Content, Sider } = Layout;

export const UserProfileBaseView = observer(() => {
  const profileStore = useContext(ProfileStore);
  /*  const [state, setState] = useState({
    selectKey: "1",
  }); */

  const renderChildren = () => {
    switch (profileStore.selectKey) {
      case "1":
        return <BasicSettingsView />;
      case "2":
        return <SecuritySettingsView />;
      case "3":
        return <UserPermission />;
      case "4":
        return <NotificationSettingsView />;
      default:
        break;
    }

    return null;
  };
  return (
    <Layout>
      <Content>
        <Layout style={{ padding: "24px 0", background: "#fff" }}>
          <Sider width={200} style={{ background: "#fff" }}>
            <Menu
              mode="inline"
              defaultSelectedKeys={[profileStore.selectKey]}
              selectedKeys={[profileStore.selectKey]}
              defaultOpenKeys={["sub1"]}
              style={{ height: "100%", width: "224px" }}
              onClick={({ key }) => {
                profileStore.selectKey = key;
              }}
            >
              <Menu.Item key="1">
                <span>Basic Settings</span>
              </Menu.Item>
              <Menu.Item key="2">
                <span>Security Settings</span>
              </Menu.Item>
              <Menu.Item key="3">
               
                <span>Privileges and Permissions</span>
              </Menu.Item>
              <Menu.Item key="4">
                <span>Messages & Notification</span>
              </Menu.Item>
            </Menu>
          </Sider>
          <Content style={{ padding: "0 24px", minHeight: 280 }}>
            {profileStore.isSaving && (
              <ProgressIndicator
                description="please wait while we save your modifications..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            )}
            {renderChildren()}
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
});

